<!--
 * @Description: 新加群标签组件
 * @Author: yuxin
 * @Date: 2025-08-01 10:18:50
 * @LastEditors: Do not edit
 * @LastEditTime: 2025-08-18 14:22:00
 * @FilePath: \mgr_web\src\views\group\components\addTags.vue
-->
<template>
  <div class="addTags-container">
    <el-dialog
      title="添加标签"
      :visible.sync="tagVisible"
      :close-on-click-modal="false"
      width="30%"
      close-on-press-escape
      @close="close"
      v-loading="loading"
    >
      <el-select
        v-model="uid"
        placeholder="请选择"
        size="small"
        style="width: 100%"
      >
        <el-option
          v-for="item in tagList"
          :key="item.groupId"
          :label="item.groupName"
          :value="item.groupId"
        />
      </el-select>
      <div style="margin: 30px 0;width:100%">
        <el-checkbox-group v-model="checkList">
          <div
            v-for="(i, index) in tagItemList"
            :key="index"
            class="checkbox-wrap"
          >
            <el-checkbox :label="i.tagId">{{ i.tagName }}</el-checkbox>
          </div>
        </el-checkbox-group>
      </div>
      <div class="selected-bar-wrap">
        <div class="selected-bar-title">已选：</div>
        <el-tag
          class="tag-item"
          size="small"
          v-for="(item, index) in selectedTagNames"
          :key="index"
          >{{ item.tagName }}</el-tag
        >
      </div>
      <div style="text-align: right">
        <el-button type="primary" size="mini" @click="handleTags"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { activityTagType } from "@/api/activeCode/activeCode.js";
export default {
  data() {
    return {
      /** 控制标签弹窗显示隐藏 */
      tagVisible: false,
      /** 标签列表 */
      tagList: [],
      /** 选中的标签列表 */
      checkList: [],
      /** 存储标签数组 */
      tagItemList: [],
      /** 选中的标签 */
      uid: "",
      /** 选中的数据 */
      tagChildList: [],
      /** 控制弹窗加载动画 */
      loading: false,
      //   /** 选中的数组名称 */
      //   selectedTagNames: [],
    };
  },
  methods: {
    /** 初始化 */
    init(selectedData) {
      if (selectedData) {
        /** 已选数据回显 */
        this.checkList = selectedData.map((item) => item.tagId);
      }
      this.tagVisible = true;
      /** 获取标签数据 */
      this.$nextTick(() => {
        this.getTagsGroup();
      });
    },

    /** 点击确认 */
    handleTags() {
      let selectedData = [];
      if (this.checkList && this.checkList.length) {
        selectedData = this.tagChildList.filter((item) => {
          return this.checkList.includes(item.tagId);
        });
      }
      //  else {
      //   return this.$message.warning("请至少选择一个");
      // }
      /** 向父组件传递数据 */
      // if (this.checkList && this.checkList.length) {
      this.$emit("getSelectedTage", selectedData);
      // }

      this.tagVisible = false;
    },

    /** 获取标签组 */
    getTagsGroup() {
      /** 开启加载动画 */
      this.loading = true;
      activityTagType(
        this.searchParams,
        localStorage.getItem("Authorization")
      ).then((res) => {
        if (res.error.code == 200) {
          this.tagList = res.data.records;
          let list = res.data.records.map((item) => {
            if (item.hmcActivityTagList.length > 0) {
              return item.hmcActivityTagList;
            }
          });
          this.uid = [];
          /** flat() 方法创建一个新的数组，并根据指定深度递归地将所有子数组元素拼接到新的数组中 */
          this.tagChildList = list.flat(Infinity);
          console.log("sdfsfsd", this.tagChildList[0].groupId);
          /** 默认选中第一个标签组 */
          this.uid =
            this.tagChildList &&
            this.tagChildList[0] &&
            this.tagChildList[0].groupId;
        }
        this.loading = false;
      });
    },

    /** 关闭弹窗触发 */
    close() {
      this.tagVisible = false;
      this.$emit("closeTageDia");
    },
  },

  /** 计算属性 */
  computed: {
    /** 获取选中数据 */
    selectedTagNames() {
      console.log("你不触发");
      let nameList = [];
      if (this.checkList && this.checkList.length) {
        nameList = this.tagChildList.filter((item) => {
          return this.checkList.includes(item.tagId);
        });
      }
      return nameList;
    },
  },

  /** 监听分组数据变化 */
  watch: {
    /** 分组数据变化切换组下标签 */
    uid: {
      handler(newVal) {
        console.log("dfsdfsdf", newVal);
        this.tagItemList =
          this.tagList.filter((item) => item.groupId == newVal).length > 0
            ? this.tagList.filter((item) => item.groupId == newVal)[0][
                "hmcActivityTagList"
              ]
            : [];
      },
    },
  },

  /** 生命周期 */
  created() {},
};
</script>
<style lang="scss" scoped>
.addTags-container {
  width: 100%;
  .selected-bar-wrap {
    display: flex;
    align-items: center;
    width: 100%;
    flex-wrap: wrap;
    .selected-bar-title {
      flex-shrink: 0;
      margin-bottom: 6px;
    }
    .tag-item {
      margin-right: 6px;
      margin-bottom: 6px;
      max-width: 400px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  /deep/.el-checkbox {
    display: flex;
    align-items: center;
  }
  /deep/.el-checkbox__label {
    max-width: 400px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
